import { Pipe, PipeTransform } from '@angular/core';
import { CustomerAddress } from '../../customer/models/customer-address.model';

@Pipe({ name: 'addressType' })
export class AddressTypePipe implements PipeTransform {
    transform(items: CustomerAddress[], addressType) {
        if (items) {
            return items.filter(function(x, i) {
                return (x.addressTypeId === +(addressType.id));
            });
        } else {
            return new Array();
        }
    }
}
